import { render, staticRenderFns } from "./PazienteTerapiaListComponent.vue?vue&type=template&id=4f7f857e&scoped=true"
import script from "./PazienteTerapiaListComponent.vue?vue&type=script&lang=js"
export * from "./PazienteTerapiaListComponent.vue?vue&type=script&lang=js"
import style0 from "./PazienteTerapiaListComponent.vue?vue&type=style&index=0&id=4f7f857e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7f857e",
  null
  
)

export default component.exports